import { render, staticRenderFns } from "./DuplicateProjectModal.vue?vue&type=template&id=6b81e306&scoped=true"
import script from "./DuplicateProjectModal.vue?vue&type=script&lang=ts"
export * from "./DuplicateProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./DuplicateProjectModal.vue?vue&type=style&index=0&id=6b81e306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b81e306",
  null
  
)

export default component.exports